import React, { useEffect, useState } from "react";
import { Image } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export const Header = () => {
	const [fixedNav, setFixedNav] = useState(false);
	const [collapsed, setCollapsed] = useState(false);

	window.addEventListener("resize", () => {
		if (window.innerWidth < 800) setFixedNav(true);
		else setFixedNav(false);
	});
	useEffect(() => {
		if (window.innerWidth < 800) setFixedNav(true);
		else setFixedNav(false);
	}, []);

	const triggerActivity = () => {
		setCollapsed(!collapsed);

		document
			.querySelectorAll(".icon-bar")
			.forEach((el) => el.classList.toggle("active"));
		document
			.querySelectorAll(".lowerbar")
			.forEach((el) => el.classList.toggle("active"));
		document.querySelector(".burger-icon").classList.toggle("active");
	};

	const handleLinkClick = () => {
		if (collapsed) {
			triggerActivity();
		}
	};

	return (
		<Navbar
			fixed={fixedNav ? "top" : ""}
			className="bg-transblack"
			variant="dark"
			expand="md"
			as={motion.div}
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			transition={{ duration: 1, delay: 6 }}
		>
			<Container className="d-flex align-items-center">
				<Navbar.Brand as={Link} to={"/"} className="d-md-none">
					AA
				</Navbar.Brand>
				<Navbar.Toggle
					className="burger-icon"
					onClick={triggerActivity}
				>
					<span className="icon-bar"></span>
					<span className="icon-bar"></span>
					<div className="d-flex w-100">
						<span className=" lowerbar"></span>
						<span className=" lowerbar"></span>
					</div>
				</Navbar.Toggle>
				<Navbar.Collapse id="basic-navbar-nav" in={collapsed}>
					<Nav className="w-100 d-flex justify-content-evenly align-items-center">
						<Nav.Link
							className="text-white navlinks"
							as={Link}
							to={"/skills"}
							onClick={handleLinkClick}
						>
							Skill Set
						</Nav.Link>
						<Nav.Link
							className="text-white navlinks"
							as={Link}
							to={"/passion"}
							onClick={handleLinkClick}
						>
							About Me
						</Nav.Link>
						<div className="d-none d-md-block ">
							<Nav.Link className="text-white" as={Link} to={"/"}>
								<Image
									fluid
									roundedCircle
									className="navLogo"
									src={require("../images/logo.png")}
								/>
							</Nav.Link>
						</div>
						<Nav.Link
							className="text-white navlinks"
							as={Link}
							to={"/projects"}
							onClick={handleLinkClick}
						>
							Projects
						</Nav.Link>
						<Nav.Link
							className="text-white navlinks"
							as={Link}
							to={"/contact"}
							onClick={handleLinkClick}
						>
							Contact
						</Nav.Link>
					</Nav>
				</Navbar.Collapse>
			</Container>
		</Navbar>
	);
};
